import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import { pujaServiceID, pujaSubServiceID, ServiceDiscounts } from "../../Components/enum";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import banner from '../../assets/images/new/orderPageBanner.png'
import DailyPujaBookingBannerImg from "../../assets/images/new/DailyPoojaBookingBannerImg.png";
import { t } from "i18next";
import { GetPujaOrderListByUserIDList } from "../../ApiServices/Puja/PujaApi";

const RemedyPujaOrderPage = () => {
    const userKeyID = localStorage.getItem("userKeyID");
    const [orders, setOrders] = useState([]);
    const { setLoader, loader, selectedLanguageID, formatToIndianCurrency } = useContext(LoaderContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [pageHeading, setPageHeading] = useState("My Orders")


    useEffect(() => {

        if (location?.pathname === "/my-order-remedy-Booking") {
            GetPujaOrderDetailsData(pujaServiceID?.Puja, pujaSubServiceID?.RemedyPuja, 1)
            setPageHeading(t("Remedy Puja"))
        } else if (location?.pathname === "/my-order-homam-Booking") {
            GetPujaOrderDetailsData(pujaServiceID?.Puja, pujaSubServiceID?.HomamPuja, 1)
            setPageHeading(t("Homam"))
        }
    }, [])


    const GetPujaOrderDetailsData = async (pujaServiceID, pujaSubServiceID, pageNumber) => {

        setLoader(true);
        try {
            const response = await GetPujaOrderListByUserIDList({
                pageSize: 30,
                pageNo: pageNumber - 1,
                pujaServiceID: pujaServiceID,
                pujaSubServiceID: pujaSubServiceID
            }, userKeyID, selectedLanguageID);

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                setOrders(list);


            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };


    const orderDetails = (myorders) => {
        navigate("/order-details", { state: { order: myorders } });
    };
    return (
        <>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${DailyPujaBookingBannerImg})` }}></div>
                <div className="container" >
                    <h2 className="page-header__title bw-split-in-left">{`${pageHeading}`}</h2>
                </div>
            </section>
            <div className="p-3 m-4 my-4">
                {orders?.length > 0 ? (
                    <div className="row gx-4 gy-4" style={{ justifyContent: 'left' }}>
                        {orders.map((puja) => (
                            <div className="col-xl-4 col-lg-4 col-md-6" key={puja.id}>
                                <div
                                    className="card border-0 shadow-lg p-2 h-100"
                                    onClick={() => orderDetails(puja)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="d-flex align-items-start">
                                        <img
                                            src={puja?.pujaImageUrl || Batuk}
                                            alt={puja.pujaName}
                                            className="rounded me-3"
                                            style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                        />
                                        <div >
                                            <h6 className="mb-1 text-truncate" style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word", fontSize: "12px"
                                            }} title={puja.pujaName}>
                                                {puja.pujaName}
                                            </h6>
                                            <span className="fw-bold text-muted">#{puja.bookingID}</span>
                                            {puja.bookingDate && (
                                                <p className="mb-1"><strong>{t("Booking Date")}:</strong> {puja.bookingDate || '-'}</p>
                                            )}

                                            {/* <p className="mb-1" style={{ fontSize: "12px" }}><strong>{t("Puja Type")}:</strong> {t(puja.pujaType || "Offline")}</p> */}
                                            <p className="mb-1" style={{ fontSize: "12px" }}>
                                                <strong>{t("Payment Status")}:</strong>{" "}
                                                <span
                                                    style={{
                                                        color: puja.paymentStatus === "Pending" ? "red" : "green",
                                                        fontWeight: "600", fontSize: "12px"
                                                    }}
                                                >
                                                    {puja.paymentStatus === "Complete"
                                                        ? t("Completed")
                                                        : t(puja.paymentStatus)}

                                                </span>
                                            </p>
                                            <p className="mb-1 fw-bold" style={{ fontSize: "12px" }}>
                                                <strong>{t("Total Amount")}:</strong> ₹ {formatToIndianCurrency(Math.round(puja?.totalAmount))}
                                            </p>

                                            <div className="service-two__item__rm" onClick={() => orderDetails(puja)}>
                                                <span style={{ color: '#a52444' }}> {t("View Details")}</span>
                                                <i className="icon-right-arrow"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                ) : loader === false ? (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                        <img
                            src={Batuk}
                            alt="Empty Cart"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "250px" }}
                        />
                        <h5 className="fw-bold">{t("No orders found")}</h5>
                        <button
                            className="careox-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/services/puja-booking")}
                        >
                            {t("Book now")}
                        </button>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    )
}

export default RemedyPujaOrderPage
